<div class="form-group row" *ngIf="control.visible" [formGroup]="formGroup">
  <div class="col-md-12">
    <hb-df-control-label [control]="control" (onOverrideValue)="overrideValue()"></hb-df-control-label>
  </div>
  <div class="col-md-12">
    <p-multiSelect
      *ngIf="control.isMultiSelect"
      styleClass="hb-dropdown hb-multi-select hb-dropdown-filter"
      [inputId]="control.key"
      [placeholder]="control.placeholder || control.label"
      [options]="control.options"
      [formControlName]="control.key"
      [filter]="true"
      [disabled]="control.disabled"
      [selectedItemsLabel]="'{0} items selected'"
      [defaultLabel]="control.placeholder || control.label"
      [style]="{ width: '100%' }"
      appendTo="body"
    >
    </p-multiSelect>
    
    <p-dropdown
      *ngIf="!control.isMultiSelect"
      class="form-control hb-dropdown hb-prime-dropdown hb-dropdown-filter"
      [ngClass]="{
        'is-invalid':
          control.enableValidation &&
          (control.form?.submitted || (control?.formControl?.touched && control?.showErrorsOnTouched)) &&
          control.isInvalid
      }"
      [id]="control.key"
      [placeholder]="control.placeholder || control.label"
      [options]="control.options"
      [formControlName]="control.key"
      [filter]="true"
      [virtualScroll]="false"
      [virtualScrollItemSize]="30"
      [attr.disable]="control.disabled"
      [style]="{ width: '100%' }"
      [showClear]="true"
      [editable]="control.editable"
      appendTo="body"
    >
    </p-dropdown>
    <div
      *ngIf="
        control.enableValidation && (control.form?.submitted || (control?.formControl?.touched && control?.showErrorsOnTouched)) && control.isInvalid
      "
      class="primeng-invalid-feedback div-word-wrap validation-error-text"
    >
      <div *ngIf="control?.formControl?.errors?.required" [pTooltip]="control.label + ' is required.'">{{ control.label }} is required.</div>
      <div
        *ngIf="control?.customValidators && control?.customValidatorsMessages && control?.customValidatorsMessages?.length > 0"
        class="primeng-invalid-feedback div-word-wrap validation-error-text"
      >
        <div *ngFor="let customValidator of control?.customValidatorsMessages">
          <div *ngIf="(control?.formControl?.errors)[customValidator?.name]" [pTooltip]="customValidator?.errorMessage">
            {{ customValidator?.errorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
